import { ReactNode } from "react";
import MapMarker from "../../../../../common/components/map/types/map-marker";
import mapMarkerIconFactory from "../../../../../common/components/map/marker/map-marker-icon.factory";
import { OrderOptimizerRailyListingItemRoute } from "./types/order-optimizer-raily-listing-item";

const createMapMarker = (
  route: OrderOptimizerRailyListingItemRoute,
  content?: ReactNode
): MapMarker => {
  const icon = mapMarkerIconFactory.createIcon({
    className: "map_marker standard",
    content: content,
  });

  const marker: MapMarker = {
    coordinate: {
      latitude: route.lat,
      longitude: route.lon,
    },
    icon,
  };

  return marker;
};

const areWaypointsEqual = (
  waypoint1: OrderOptimizerRailyListingItemRoute,
  waypoint2: OrderOptimizerRailyListingItemRoute
): boolean => {
  return waypoint1.lat === waypoint2.lat && waypoint1.lon === waypoint2.lon;
};

const createMapMarkers = (
  waypoints: OrderOptimizerRailyListingItemRoute[]
): MapMarker[] => {
  let mapMarkers: MapMarker[] = [];

  for (const waypoint of waypoints) {
    const allWaypointsOnThisPlace = waypoints
      .map((w, index) => ({ waypoint: w, index: index + 1 }))
      .filter((w) => areWaypointsEqual(w.waypoint, waypoint));

    const signature = allWaypointsOnThisPlace.map((w) => w.index).join("/");

    const newMarker: MapMarker = createMapMarker(waypoint, signature);

    mapMarkers = [...mapMarkers, newMarker];
  }

  return mapMarkers;
};

const orderOptimizerRailyListingMapMarkersFactory = {
  createMapMarkers,
};

export default orderOptimizerRailyListingMapMarkersFactory;
